export default {
    "de": {
        "alerts": {
            "checking": "Verbindung wird überprüft, bitte warten..",
            "keys": {
                "profileUpdate": {
                    "success": "Profil-Änderungen wurden erfolgreich gespeichert.",
                    "error": "Es ist ein Problem beim Speichern der letzten Profil-Änderungen aufgetreten."
                },
                "jobUpdate": {
                    "success": "Änderungen wurden erfolgreich hinzugefügt",
                    "error": "Es ist ein Problem beim Speichern der letzten Änderungen"
                },
                "addBreak": {
                    "success": "Eintrag wurde erfolgreich hinzugefügt",
                    "error": "Es ist ein Problem beim Speichern der letzten Eintrag aufgetreten."
                },
                "notificationsRead": {
                    "success": "Meldungen wurden aktualisiert.",
                    "error": "Meldungen konnten nicht aktualisiert werden."
                }
            }
        },
        "buttons": {
            "alert_details": "Details"
        }
    }
}